import {TYPE} from './type.enum';

export class Alerts {
  type: TYPE = TYPE.SUCCESS;
  message: string;

  constructor(message: string, type: TYPE) {
    this.type = type;
    this.message = message;
  }
}
